import { Action, createReducer, on } from '@ngrx/store';

import { CustomizableBanner } from '../../../models/customizable-banner';
import { pauseCustomizableBanner, updateCustomizableBanners } from '../actions/customizable-banner.actions';

export interface CustomizableBannerState {
  name: string;
  banners: CustomizableBanner[];
  default_banner: CustomizableBanner;
}

const initialState: CustomizableBannerState[] = [];

const reducer = createReducer(
  initialState,
  on(updateCustomizableBanners, (state: CustomizableBannerState[], { payload }) => payload),
  on(pauseCustomizableBanner, (state: CustomizableBannerState[], { id }) =>
    state.map((spot) => {
      const filteredBanners = spot.banners.filter((banner) => banner.id !== id);
      return {
        ...spot,
        banners: filteredBanners,
      };
    }),
  ),
);

export function customizableBannerReducer(
  state: CustomizableBannerState[] | undefined,
  action: Action,
): CustomizableBannerState[] {
  return reducer(state, action);
}
